import Backbone from '@polleverywhere/backbone'
import { slice as appSlice } from '../../slices/app'
import store from '@polleverywhere/redux'

function updateRoute () {
  const pageToRoute = _.invert(this.routes)

  const { page } = store.getState()[appSlice.name]

  if (_.has(pageToRoute, page)) {
    const route = pageToRoute[page]
    this.navigate(route, { trigger: false })
  }

  if (['login', 'log in'].includes(page)) {
    this.navigate('login', { trigger: false })
  }
}

function defaultRoute () {
  // this.state.appStates.activities.changePage(path)
  store.dispatch(appSlice.pageUpdatedToDefault())
}

/**
 * Updates URL when state changes. Also, update the state model
 * from the initial route.
 */
export default class Router extends Backbone.Router {
  get routes () {
    return {
      home: 'home',
      logout: 'logout',
      support: 'support',
      feedback: 'feedback',
      // Profile route is deprecated but it is linked to directly from within
      // presenter apps. Thus, we cannot remove it until the oldest version that
      // references it is officially sunsetted. For now, keep it as an alias to
      // the `settings` route.
      profile: 'settings',
      settings: 'settings',
      signup: 'signup',
      reset_password: 'reset_password',
      login: 'login',
      '': defaultRoute.bind(this),
      'office/index.html': defaultRoute.bind(this),
      // Catch all
      '*args': () => {
        store.dispatch(appSlice.pageUpdated('not_found'))
      }
    }
  }

  initialize (options = {}) {
    _.defaults(options, {
      updateURL: true
    })

    this.state = options.state

    // Update route based on state changes
    if (options.updateURL) {
      // Listen to redux change
      store.subscribe(updateRoute.bind(this))

      // If we hit a named route, update the url. e.g. settings, login, etc.
      this.on('route', (route, params) => {
        if (route.length) {
          store.dispatch(appSlice.pageUpdated(route))
        }
      })

      // After we've logged out, put the url back to '/' so it's not hanging out at '/logout'
      this.listenTo(this.state, 'session:logout', () => {
        this.navigate('/', { trigger: false })
      })
    }
  }
}
